/* eslint new-parens: 0 */
/* globals EasyPost Backbone */
import React from 'react';

import { setLocation } from 'utils/wrappers';

import Base from 'app/routers/base';

import CheckoutBillingPage from 'app/components/pages/checkout/billing';
import CheckoutConfirmationPage from 'app/components/pages/checkout_confirmation';
import CheckoutSuccessPage from 'app/components/pages/checkout/success';
import PasswordResetPage from 'app/components/pages/password_reset_page';
import PasswordResetRequestPage from 'app/components/pages/password_reset_request';
import ShippingCalculatorPage from 'app/components/pages/shipping_calculator';
import SignInView from 'app/components/pages/sign_in';
import SignUpView from 'app/components/pages/sign_up';
import TalkToEasyPostPage from 'app/components/pages/talk_to_easypost';
import USPSZoneLookupPage from 'app/components/pages/usps_zone_lookup';
import VerificationSplashPage from 'app/components/pages/verification_splash';
import VerificationSubmitPage from 'app/components/pages/verification_submit';

export const CHECKOUT_BILLING_PAGE = '/checkout/billing';
export const CHECKOUT_SIGNUP_PAGE = '/checkout/signup';
export const CHECKOUT_CONFIRMATION_PAGE = '/checkout/confirmation';
export const GETTING_STARTED_PAGE = '/getting-started';
export const RESET_PAGE = '/reset';

const DefaultRouter = Base.extend({
  routes: {
    reset: 'requestPasswordResetEmail',
    'reset-confirmation': 'passwordResetConfirmation',
    'shipping-calculator': 'calculator',
    signin: 'signin',
    signup: 'signup',
    'checkout/signup': 'signupForCheckout',
    'checkout/signin': 'signinForCheckout',
    'checkout/confirmation': 'checkoutConfirmation',
    'checkout/success': 'checkoutSuccess',
    'checkout/billing': 'checkoutBilling',
    'talk-to-easypost': 'contact',
    verification: 'verificationSplash',
    'usps-zone-lookup': 'uspsZoneLookupPage',
    'usps-zone-lookup.html': 'uspsZoneLookupPage',
  },
  verificationSplash() {
    // we can't have dynamic pages with our static site, so must look for the location hash
    const code = this.checkForHash();
    this.enforceNotLoggedIn({
      callback: () => {
        if (code.length) {
          this.renderView(new VerificationSubmitPage({ code }));
        } else {
          this.renderView(new VerificationSplashPage({}));
        }
      },
    });
  },
  contact() {
    this.renderView(new TalkToEasyPostPage({}));
  },
  signup() {
    this.enforceNotLoggedIn({
      callback: () => this.renderView(new SignUpView()),
      redirect: () => setLocation(GETTING_STARTED_PAGE),
    });
  },
  signupForCheckout() {
    if (this.enforceCheckoutFlow()) {
      this.enforceNotLoggedInIncludeUnverified({
        callback: () => this.renderView(new SignUpView({ redirect: CHECKOUT_BILLING_PAGE })),
        redirect: () => setLocation(CHECKOUT_BILLING_PAGE),
      });
    }
  },
  signin() {
    this.enforceNotLoggedIn({
      callback: () => this.renderView(new SignInView({})),
    });
  },
  signinForCheckout() {
    if (this.enforceCheckoutFlow()) {
      this.enforceNotLoggedInIncludeUnverified({
        callback: () => this.renderView(new SignInView({ redirect: CHECKOUT_BILLING_PAGE })),
        redirect: () => setLocation(CHECKOUT_BILLING_PAGE),
      });
    }
  },
  calculator() {
    this.renderView(new ShippingCalculatorPage({}));
  },
  requestPasswordResetEmail() {
    this.enforceNotLoggedIn({
      callback: () => this.renderView(new PasswordResetRequestPage({})),
    });
  },
  passwordResetConfirmation() {
    const token = this.checkForHash();
    if (token.length) {
      this.renderView(new PasswordResetPage({ token }));
    } else {
      setLocation(RESET_PAGE);
    }
  },
  checkoutConfirmation() {
    if (this.enforceCheckoutFlow()) {
      this.enforceLoginAllowUnverified({
        callback: () => this.renderView(new CheckoutConfirmationPage()),
        redirect: CHECKOUT_SIGNUP_PAGE,
      });
    }
  },
  checkoutBilling() {
    if (this.enforceCheckoutFlow()) {
      this.waitForUserLoad(() => {
        if (EasyPost.Globals.currentUser.get('has_billing_method')) {
          Backbone.history.navigate(CHECKOUT_CONFIRMATION_PAGE, { trigger: true, replace: true });
        } else {
          this.enforceLoginAllowUnverified({
            callback: () => this.renderView(new CheckoutBillingPage({
              user: EasyPost.Globals.currentUser,
            })),
            redirect: CHECKOUT_SIGNUP_PAGE,
          });
        }
      });
    }
  },
  checkoutSuccess() {
    if (this.enforceCheckoutFlow()) {
      this.enforceLoginAllowUnverified({
        callback: () => this.renderView(new CheckoutSuccessPage()),
      });
    }
  },
  uspsZoneLookupPage() {
    this.renderReactComponent(<USPSZoneLookupPage />);
  },
});

export default DefaultRouter;



// WEBPACK FOOTER //
// ./app/routers/default_router.jsx